export default __webpack_public_path__ + "static/media/renda.11411f1e.png";